module.exports = __webpack_public_path__ + "static/media/SD.808944c3.svg";